import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

export interface NavLinkItem {
  label: string;
  path: (string | number)[] | string;
}

@Component({
  selector: 'app-generated-reports',
  templateUrl: './generated-reports.component.html',
  styleUrls: ['./generated-reports.component.scss'],
})
export class GeneratedReportsComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}
  pageData = {
    id: 11,
    name: 'reports',
    displayPageName: 'Reports',
  };
  isNewWindow: boolean = false;
  isHasAccess: boolean = false;
  rightsError: string = '';

  navLinks: NavLinkItem[] = [
    {
      label: 'Mileage Reports',
      path: ['mileage'],
    },
    {
      label: 'Trip Performance',
      path: ['trip-performance'],
    },
  ];

  ngOnInit() {
    setTimeout(() => {
      this.isHasAccess = this.authService.isHasAccess(this.pageData);
      this.rightsError = "You don't have access rights to this module.";
    }, 500);
  }

  openWindow() {
    this.router.navigate(['/account/home']);
    let newwin = window.open(
      'account/report/mileage/2',
      'Reports',
      'height=' + screen.height + ', width=' + screen.width + ' '
    );
    if (window.focus) {
      newwin.focus();
    }
    return false;
  }
}
